var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading circle",class:{ signup: _vm.signUpLoading }},[_c('div',{staticClass:"loader",style:(_vm.loadingStyles)},[_vm._v("\n    Loading...\n  ")]),_vm._v(" "),(_vm.showText)?_c('div',{staticClass:"text"},[_vm._v("\n    Loading...\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }